import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

import { getDraftPaymentRequest } from '@src/api'
import {
  DefaultApiGetDraftPaymentRequestRequest,
  GetDraftPaymentRequest200Response,
} from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'
import { CustomError } from '@src/types'

export const useFetchDraftPaymentRequest = (
  isDraft: boolean,
  params: DefaultApiGetDraftPaymentRequestRequest
) => {
  const { axiosInstance } = useAxios()
  return useQuery<
    AxiosResponse<GetDraftPaymentRequest200Response>,
    AxiosResponse<CustomError>
  >({
    enabled:
      !!params.organizationId && !!params.draftPaymentRequestId && isDraft,
    queryFn: () => getDraftPaymentRequest(axiosInstance, params),
    queryKey: [REACT_QUERY_CACHE_KEYS.GET_DRAFT_PAYMENT_REQUEST, params],
  })
}
